package com.bikompanion.data

import io.ktor.client.HttpClientConfig
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logger
import io.ktor.client.plugins.logging.Logging

internal const val NETWORK_LOG_TAG = "AparcadorNet"

/** Writes to whatever the platform's log console actually is (Logcat, browser console, stdout). */
internal expect fun logNetwork(
    tag: String,
    message: String,
)

internal fun logRatingDiagnostic(message: String) = logNetwork("Ratings", message)

/**
 * Installs request/response logging with a [tag] identifying which API the call belongs to,
 * so logs from the different clients can be told apart.
 */
internal fun HttpClientConfig<*>.installLogging(tag: String) {
    install(Logging) {
        // Not ALL: stations are polled every 30s, and full payloads at that rate bury
        // everything else in the log.
        level = LogLevel.INFO
        logger = object : Logger {
            override fun log(message: String) = logNetwork(tag, message)
        }
    }
}
